module.exports = __webpack_public_path__ + "static/img/church_02.482c8d0.png";


//////////////////
// WEBPACK FOOTER
// ./src/common/pc/images/church_02.png
// module id = /Lgm
// module chunks = 0